export const mockCustomerData = []
